import Vue from 'vue';

export default Vue.filter('cep', value => {
  let cep = value.toString();
  cep = `${cep.substr(0, 5)}-${cep.substr(5, 7)}`;
  return cep;
});
